(function () {
    const imageContainer = document.querySelector('#occasion-images');
    const closeButton = document.querySelector('#op-grid-overlay-button');
    const html = document.querySelector('html');
    const gridOverlay = document.querySelector('.op-grid-overlay');

    if (imageContainer === null || closeButton === null || html === null || gridOverlay === null) {
        return;
    }

    const onPreviewImageClick = () => {
        html.style.overflow = 'hidden';
        gridOverlay.classList.add('open');
    };

    const onGridImageClick = (index) => {
        const gallery = document.querySelector('#occasion-gallery');
        const gallerySlider = gallery.querySelector('swiper-slider');
        if (gallery == null || gallerySlider === null) {
            return true;
        }
        console.log(index);
        gallery.open = true;
        gallerySlider.slideTo(index);
    }

    /**
     * Open the gallery
     * @param {Event}
     */
    imageContainer
        .querySelectorAll('img')
        .forEach(
            (image) => image.addEventListener('click', onPreviewImageClick)
        );

    gridOverlay
        .querySelectorAll('.op-grid-overlay-img')
        .forEach(
            (image, index) => image.addEventListener('click', () => {
                onGridImageClick(index+1)
            })
        );

    closeButton.addEventListener('click', () => {
        html.style.overflow = null;
        gridOverlay.classList.remove('open');
    });
})();



// WEBPACK FOOTER //
// ./scripts/custom/occasions/occasionDetailGrid.js